import { ActionIcon, Flex, Select, Text } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useMemo } from "react";

import { useTheme } from "../../../../../hooks";
import { Button } from "../../../../shared/Button/Button";
import { type Entities, type SelectedColumn } from "../CrewTransfer.model";
import {
  StyledColumnSelector,
  StyledColumnSelectorInputs,
  StyledSelectedColumn,
} from "../styled/columnSelector.styled";

interface Props {
  selectedColumns: SelectedColumn[];
  setSelectedColumns: (vessels: SelectedColumn[]) => void;
  entities: Entities;
}

const ColumnsSelector = ({
  entities,
  selectedColumns,
  setSelectedColumns,
}: Props) => {
  const theme = useTheme() as any;

  const selectData = useMemo(
    () =>
      entities
        ? Object.values(entities.columns).map(({ title, id }) => ({
            label: title,
            value: id,
          }))
        : [],
    [entities],
  );
  const handleRemove = (value: string) => {
    setSelectedColumns(selectedColumns.filter(el => el.id !== value));
  };

  const handleSelectChange = (value: string) => {
    if (selectedColumns.find(el => el.id === value)) handleRemove(value);
    else setSelectedColumns([...selectedColumns, entities?.columns[value]]);
  };

  return (
    <StyledColumnSelector>
      <StyledColumnSelectorInputs>
        <Select
          data={selectData}
          onChange={handleSelectChange}
          value=""
          placeholder={"Select vessel to show"}
          maw={250}
        />
        {selectedColumns.length > 0 && (
          <Button
            size="xs"
            onClick={() => setSelectedColumns([])}
            className="fadeIn">
            <Text fw={200}>Clear</Text>
          </Button>
        )}
      </StyledColumnSelectorInputs>

      <Flex wrap="wrap" gap={10}>
        {selectedColumns.map((vessel, index) => (
          <StyledSelectedColumn key={index} className="fadeIn">
            <Text size="sm" fw={200}>
              {vessel.title}
            </Text>
            <ActionIcon onClick={() => handleRemove(vessel.id)}>
              <IconX />
            </ActionIcon>
          </StyledSelectedColumn>
        ))}
      </Flex>
    </StyledColumnSelector>
  );
};
export default ColumnsSelector;
